var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "10px",
    viewBox: "0 0 17 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Property--banner-(pending)",
    transform: "translate(-106.000000, -142.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(97.000000, 137.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(9.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5,10 C3.91375869,10 0.311169989,5.642768 0.160374792,5.4526598 C-0.053458264,5.18949108 -0.053458264,4.81049178 0.160374792,4.5473402 C0.311122217,4.36052332 3.91375869,0 8.5,0 C13.0862414,0 16.6888302,4.36066046 16.8396252,4.54665451 L16.8396252,4.54732477 C17.0534583,4.81049349 17.0534583,5.18949279 16.8396252,5.45264437 C16.6888778,5.64282114 13.0862414,10 8.5,10 L8.5,10 Z M1.66390462,4.99993143 C2.66600252,6.05123493 5.39076743,8.57101716 8.50000003,8.57101716 C11.6092326,8.57101716 14.3359526,6.05315487 15.3360956,4.99993143 C14.3339975,3.94862793 11.6092326,1.42884571 8.50000003,1.42884571 C5.39076743,1.42884571 2.66404746,3.94670799 1.66390462,4.99993143 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5,8 C7.57146414,8 6.68148166,7.68361751 6.02531828,7.12115576 C5.3691549,6.55869401 5,5.79585188 5,5 C5,4.20414812 5.3691129,3.44126999 6.02531828,2.87884424 C6.68152366,2.31641848 7.57150614,2 8.5,2 C9.42849386,2 10.3185183,2.31638249 10.9746817,2.87884424 C11.6308451,3.44130599 12,4.20414812 12,5 C12,5.79585188 11.6308871,6.55873001 10.9746817,7.12115576 C10.3184763,7.68358152 9.42849386,8 8.5,8 Z M8.50014817,4 C7.89331302,4 7.34624152,4.36493644 7.11420731,4.92606694 C6.88215511,5.48649541 7.01013934,6.13129505 7.43977525,6.56022543 C7.86870551,6.98985785 8.51350499,7.11784572 9.0739333,6.88579345 C9.63506366,6.65374118 10,6.10668754 10,5.49985223 C10,5.10186575 9.84249036,4.72074632 9.56052109,4.43947902 C9.27925387,4.15750969 8.89813454,4 8.50014817,4 Z",
    id: "Fill-2"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewIcon);
export default __webpack_public_path__ + "static/media/preview_icon.6f8e9f0a3c736eab570347d928de90dd.svg";
export { ForwardRef as ReactComponent };